import React, { ButtonHTMLAttributes, DetailedHTMLProps } from "react";

type Props = DetailedHTMLProps<
  ButtonHTMLAttributes<HTMLButtonElement>,
  HTMLButtonElement
>;

const Button = ({ className, ...props }: Props) => {
  return (
    <button
      {...props}
      className={` ${className} rounded-xl font-normal`}
    />
  );
};

export default Button;
